import React, { useState, useEffect, useRef } from "react";
import arrowDown from "../../../assets/icons/purple-chevron-down.svg";
import './styles.scss';

const SearchableDropdown = ({
  options = [],
  label,
  onSelect,
  value,
  placeholder = "Select an option",
  className = ""
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value || null);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    onSelect(option);
    setIsOpen(false);
    setSearchTerm(""); // reset search
  };

  const toggleDropdown = () => setIsOpen(prev => !prev);

  // 🔍 Filter logic
  const filteredOptions = options.filter(opt =>
    opt.label?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={`b-searchable-dropdown ${className}`} ref={dropdownRef}>
      {label && <div className="dropdown-label">{label}</div>}

      <div className={`dropdown-header ${isOpen ? "open" : ""}`} onClick={toggleDropdown}>
        <span>{selectedOption ? selectedOption.label : placeholder}</span>

        <img
          src={arrowDown}
          alt="arrow icon"
          className={`dropdown-icon ${isOpen ? "rotate" : ""}`}
        />
      </div>

      {isOpen && (
        <div className="dropdown-list">

          {/* 🔍 Search Input */}
          <div className="dropdown-search">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()} // prevent closing
            />
          </div>

          {/* Options */}
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={option.value || index}
                className={`dropdown-item ${
                  selectedOption?.value === option.value ? "selected" : ""
                }`}
                onClick={() => handleOptionSelect(option)}
              >
                {option.label}
                <span className={`dot ${option.isActive ? "active" : option.isActive === false ? "inactive" : ""}`}></span>
              </div>
            ))
          ) : (
            <div className="dropdown-item no-options">No results found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;